<template>
  <div class="footer-module">
    <div class="content">
      <div class="content-left">
        <div class="logo">
          <div class="logo-wordmark" aria-label="大赛官方报名">
            <span class="logo-wordmark__title">大赛官方报名</span>
          </div>
        </div>
        <div class="links" v-if="0">
          <a href="#">关于我们</a>
          <a href="#">平台介绍</a>
          <a href="#">发展历程</a>
          <a href="#">联系我们</a>
        </div>
        <div class="footer">
          <div class="links">
            <span><h3>友情链接:</h3></span>
            <span><a href="#">清华大学美术学院</a></span>
            <!-- <span><a href="#">中国工艺美术学会</a></span> -->
          </div>

          <div class="links">
            <span>技术支持：艺科美刻（北京）科技有限公司</span>
            <span>|</span>
            <span>邮箱：ykmeik@163.com</span>
            <span>|</span>
            <span>地址：北京市海淀区双清路77号院2号楼8层101</span>
            <span>|</span>
            <span>电话：136-3979-2653</span>
          </div>
          <div class="company-website">
            <span>版权所有 © 艺科美刻 京ICP备2022011628号-1</span>
          </div>
        </div>
      </div>
      <div class="content-right"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer-module {
  background-color: #f7f8fa;

  .content {
    margin: 0 auto;
    width: 1280px;
    display: flex;
    padding: 30px 0 10px 0;
    justify-content: space-between;

    .content-left {
      width: 1080px;

      .logo {
        display: inline-flex;
        align-items: center;
      }

      .logo-wordmark {
        position: relative;
        display: inline-flex;
        align-items: center;
        min-height: 56px;
        padding-bottom: 10px;
      }

      .logo-wordmark::after {
        content: "";
        position: absolute;
        left: 4px;
        right: 4px;
        bottom: 0;
        height: 2px;
        background: linear-gradient(90deg, rgba(194, 124, 63, 0), rgba(194, 124, 63, 0.88), rgba(194, 124, 63, 0));
      }

      .logo-wordmark__title {
        color: #7b3622;
        font-size: 30px;
        line-height: 1;
        letter-spacing: 6px;
        font-weight: 600;
        white-space: nowrap;
        font-family: "STKaiti", "KaiTi", "FangSong", "Times New Roman", serif;
        background: linear-gradient(135deg, #5b2417 0%, #b96f3f 45%, #7a2f1b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: 0 6px 18px rgba(117, 57, 33, 0.14);
      }

      .links {
        display: flex;
        justify-content: left;
        margin: 25px 0 0 0;

        a {
          margin-right: 30px;
          color: #666666;
        }
      }
    }

    .content-right {
      margin-top: 30px;
      width: 120px;
      display: flex;
      justify-content: space-between;

      .qrcode-list {
        width: 90px;
        text-align: center;

        span {
          margin-top: 10px;
        }
      }
    }
  }

  .footer {
    margin: 0 auto;
    width: 1280px;
    padding: 5px 0 20px 0;

    .links {
      display: flex;
      justify-content: left;
      margin: 10px 0 5px 0;
      flex-wrap: wrap;
      gap: 10px 0;

      span {
        margin-right: 30px;

        h3 {
          color: #666666;
        }

        a {
          color: #666666;
        }
      }
    }

    .company-website {
      margin: 0 auto;
      justify-content: center;
      padding-top: 15px;
      text-align: left;
    }
  }
}

@media (max-width: 900px) {
  .footer-module {
    .content {
      width: 100%;
      min-width: 0;
      display: block;
      padding: 22px 16px 8px;

      .content-left {
        width: 100%;

        .logo-wordmark {
          min-height: 38px;
        }

        .logo-wordmark__title {
          font-size: 22px;
          letter-spacing: 3px;
        }

        .links {
          margin-top: 14px;
          flex-wrap: wrap;
          gap: 8px 12px;

          a,
          span {
            margin-right: 0;
          }
        }
      }

      .content-right {
        display: none;
      }
    }

    .footer {
      width: 100%;
      min-width: 0;
      padding: 0 0 18px;

      .links {
        gap: 6px 10px;

        span {
          margin-right: 0;
          line-height: 1.7;
        }
      }

      .company-website {
        text-align: left;
        line-height: 1.7;
      }
    }
  }
}
</style>
